import { render, staticRenderFns } from "./UserHistorical.vue?vue&type=template&id=9b5803ca&scoped=true"
import script from "./UserHistorical.vue?vue&type=script&lang=js"
export * from "./UserHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5803ca",
  null
  
)

export default component.exports